import { choices } from 'bvdash/utils/graphql'

export const assignedToChoices = list =>
  choices(list, ({ id, fullName }) => [id, fullName])
